import Vue from 'vue'
import {
  Button,
  Radio,
  Table,
  TableColumn,
  Input,
  Form,
  FormItem,
  Message,
  MessageBox,

} from 'element-ui'


Vue.use(Button)
Vue.use(Radio)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)

// Vue.use(Message);
// Vue.use(MessageBox);
// Vue.use(Notification);
// Vue.component(MessageBox.name, MessageBox);
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox // fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css'
// collapse 展开折叠

